<section>
  <h1 class="!mb-0 !text-base !font-semibold">
    Features to control@if (required) {
    <sup class="text-errorRed-50">*</sup>
  }
</h1>

<div class="flex flex-wrap gap-4">

  @if (features.length) {
    @for (feature of features; track feature) {
      <mat-checkbox
        [checked]="feature.selected"
        (change)="_setFeatureSelection(feature, $event.checked)"
        [disabled]="disabled"
        >
        {{ feature.it.name }} [{{ feature.it.unit }}]
      </mat-checkbox>
    }
  } @else {
    <ion-skeleton-text animated class="w-[115px] h-5" />
    <ion-skeleton-text animated class="w-[115px] h-5" />
    <ion-skeleton-text animated class="w-[115px] h-5" />
  }

</div>
</section>

